import {
	createApp,
} from 'vue';
import initializeSentry from './sentry';
import getTextPlugin, {
	iso6391ToLocale,
} from './trans';
import initializeComponents from './components';
import permissionDirective from './permissions';
import laravelFrontLibrary from './laravel-front-library';
import Vuetify from './vuetify';


/**
 * Creates the base setup for vue
 *
 * @returns {object} app
 */
function initializeBaseApp () {
	window.locale = document.head.querySelector('meta[name="lang"]').content;

	const app = createApp({
	});

	initializeSentry(app);
	app.use(getTextPlugin);
	app.use(initializeComponents);
	app.use(permissionDirective);

	let color = document.head.querySelector('meta[name="color"]') ?
		document.head.querySelector('meta[name="color"]').content :
		false;

	if (!color) {
		color = '#68bd45';
	}


	app.use(laravelFrontLibrary);
	app.use(Vuetify, color);

	// Prototype globals so they can be used in templating callbacks
	app.config.globalProperties.locale = window.locale;
	app.config.globalProperties.window = window;
	app.config.globalProperties.$userId = document.head.querySelector('meta[name="user-id"]').content;
	app.config.globalProperties.$csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

	app.config.globalProperties.$language = iso6391ToLocale(window.locale);
	app.mount('#app');
	return app;
}

export default initializeBaseApp;
